import { useState, useEffect, useReducer, useContext } from "react";
import openSocket from "socket.io-client";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";

const reducer = (state, action) => {
	if (action.type === "LOAD_WHATSAPPS") {
		const whatsApps = action.payload;

		return [...whatsApps];
	}

	if (action.type === "UPDATE_WHATSAPPS") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex] = whatsApp;
			return [...state];
		} else {
			return [whatsApp, ...state];
		}
	}

	if (action.type === "UPDATE_SESSION") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex].status = whatsApp.status;
			state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
			state[whatsAppIndex].qrcode = whatsApp.qrcode;
			state[whatsAppIndex].retries = whatsApp.retries;
			state[whatsAppIndex].lastDisconnectReason = whatsApp.lastDisconnectReason;
			state[whatsAppIndex].connectedNumber = whatsApp.connectedNumber;
			return [...state];
		} else {
			return [...state];
		}
	}

	if (action.type === "DELETE_WHATSAPPS") {
		const whatsAppId = action.payload;

		const whatsAppIndex = state.findIndex(s => s.id === whatsAppId);
		if (whatsAppIndex !== -1) {
			state.splice(whatsAppIndex, 1);
		}
		return [...state];
	}

	if (action.type === "RESET") {
		return [];
	}
};

const useWhatsApps = () => {
	const [whatsApps, dispatch] = useReducer(reducer, []);
	const [loading, setLoading] = useState(true);
	const { user } = useContext(AuthContext);

	useEffect(() => {
		if (user && user.ativo === false) {
			setLoading(false);
			return;
		}
		setLoading(true);
		const fetchSession = async () => {
			try {
				const { data } = await api.get("/whatsapp/");
				dispatch({ type: "LOAD_WHATSAPPS", payload: data });
				setLoading(false);
			} catch (err) {
				setLoading(false);
				toastError(err);
			}
		};
		fetchSession();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.ativo]);

	useEffect(() => {
		if (!user || JSON.stringify(user) === '{}') return undefined;
		if (user.ativo === false) return undefined;

		const normalizeUrl = u => (u || "").trim().replace(/\/+$/, "");
		const urlsUnicas = new Set([normalizeUrl(process.env.REACT_APP_BACKEND_URL)]);
		(user.whatsapps || [])
			.map(w => normalizeUrl(w.urlBackend))
			.filter(Boolean)
			.forEach(url => urlsUnicas.add(url));
		const sockets = [];
		[...urlsUnicas].forEach(url => {
			const socket = openSocket(url.trim() + "/");
			sockets.push(socket);

			socket.on("whatsapp", data => {
				if (data.action === "update") {
					dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
				}
			});

			socket.on("whatsapp", data => {
				if (data.action === "delete") {
					dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
				}
			});

			socket.on("whatsappSession", data => {
				if (data.action === "update") {
					dispatch({ type: "UPDATE_SESSION", payload: data.session });
				}
			});
		});
		return () => {
			sockets.forEach(socket => socket.disconnect());
		};
	}, [user]);

	return { whatsApps, loading };
};

export default useWhatsApps;
